import { createContext } from 'react'
import { PageContextValue } from '../../../core/type'
import { WeddingRegistryEntry, WeddingRegistry } from '../type'

export const WeddingRegistryPageContext = createContext<PageContextValue<WeddingRegistry, WeddingRegistryEntry>>({})
